import React from 'react';
import FormGroup from './FormGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/** Props for FormInput - most are optional to support various form usages */
export interface FormInputProps {
  name?: string;
  register?: any;
  label?: string;
  placeholder?: string;
  defaultValue?: any;
  required?: boolean;
  error?: any;
  errorMessage?: string;
  onChange?: any;
  className?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  pattern?: RegExp;
  helpContent?: string;
  style?: any;
  type?: string;
  testId?: string;
  title?: string;
  value?: string;
  joinedButton?: boolean;
  joinedButtonText?: string;
  joinedButtonIcon?: any;
  joinedButtonClick?: () => void;
  joinedButtonDisabled?: boolean;
  joinedButtonTestId?: string;
}

const FormInput = ({
  name,
  label,
  placeholder,
  defaultValue,
  register,
  required,
  joinedButton,
  joinedButtonText,
  joinedButtonIcon,
  joinedButtonClick,
  joinedButtonDisabled,
  joinedButtonTestId,
  error,
  errorMessage,
  onChange,
  className,
  autoFocus,
  disabled,
  pattern,
  helpContent,
  style,
  type,
  testId,
  title,
}: FormInputProps) => (
  <FormGroup
    label={label}
    error={error}
    errorMessage={errorMessage}
    required={required}
    helpContent={helpContent}
  >
    {joinedButton ? (
      <div className="input-group">
        <input
          {...(name != null ? register(name, { required, pattern }) : {})}
          type={type ?? 'text'}
          aria-label={label}
          name={name}
          placeholder={placeholder}
          className={`form-control float-left ${className || ''}`}
          defaultValue={defaultValue}
          data-lpignore="true"
          autoComplete="off"
          onChange={onChange}
          autoFocus={autoFocus ?? false}
          disabled={disabled ?? false}
          style={style}
          data-cy={testId}
          title={title}
        />
        <button
          type="submit"
          onClick={joinedButtonClick}
          className="btn btn-primary float-left r-corners-right"
          disabled={joinedButtonDisabled || disabled}
          data-cy={joinedButtonTestId}
        >
          {joinedButtonIcon && (
            <FontAwesomeIcon icon={joinedButtonIcon} aria-hidden="true" />
          )}
          {joinedButtonText}
        </button>
      </div>
    ) : (
      <input
        {...(name != null ? register(name, { required, pattern }) : {})}
        type={type ?? 'text'}
        aria-label={label}
        name={name}
        placeholder={placeholder}
        className={`form-control ${className || ''}`}
        defaultValue={defaultValue}
        data-lpignore="true"
        autoComplete="off"
        onChange={onChange}
        autoFocus={autoFocus ?? false}
        disabled={disabled ?? false}
        style={style}
        data-cy={testId}
        title={title}
      />
    )}
  </FormGroup>
);
export default FormInput;
